export default "__VITE_ASSET__iq$yo1eb__"